import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import { mergeStyles } from '@uifabric/merge-styles';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import strings from 'owa-strings/owa-txp-strings';

let styles = require('./ReservationStatus.scss');
let classNames = require('classnames');

/**
 * Interface of Reservation status props
 */
export interface ReservationStatusProps {
    status: TxpDataRow;
    txpStyle?: TxpStyle;
}

/**
 * Component which displays the reservation status
 */
export default class ReservationStatus extends React.Component<ReservationStatusProps, {}> {
    render() {
        let { status, txpStyle } = this.props;
        let statusColor =
            txpStyle && txpStyle.primaryColor
                ? mergeStyles({
                      color: txpStyle.primaryColor,
                  })
                : styles.reservationStatus;

        return (
            <div className={txpStyle.reservationStatus}>
                {status.icon && <Icon iconName={status.icon} className={txpStyle.iconStyle} />}
                {strings.reservationStatusText}
                <span className={classNames(statusColor, styles.reservationStatusText)}>
                    {status.text}
                </span>
            </div>
        );
    }
}
